export const extensionsEn = {
  available: 'Available extensions',
  loadError: 'Failed to load extension list, please try again later',
  addError: 'Failed to add extension',
  extLimitError:
    'There is a limit on installing extensions: no more than 10 000 inclusions for all YouGile users. Unfortunately, the limit has been exceeded at the moment and you cannot use the extension',
  removeError: 'Failed to remove extension',
  addSuccess: 'Extension added successfully',
  remove: 'Disable',
  globalSettings: 'Global settings',
  extensions: 'Extensions',
  extensionItem: 'Extension',
  status: 'Extension status',
  enabled: 'Enabled',
  disabled: 'Disabled',
  enable: 'Enable',
  disable: 'Disable',
  enableOnlyAdmin: (isEnabled: boolean) =>
    `Only company administrators can ${
      isEnabled ? 'disable' : 'enable'
    } extensions`,
  rateExtension: 'Rate extension',
  setup: 'Extension settings',
  extensionsSettings: 'Extensions settings',
  extensionSettings: 'Extension settings',
  createdBy: 'created by',
  installCustom: 'Install extension',
  installsCountHint: `Number of usage`,
  commentsCountHint: `Number of comments`,
  supportOnlyZip: 'Only archives with the *.zip extension are supported',
  successOnInstall: 'The extension has been enabled successfully',
  errorOnInstall: 'Failed to enable extension',
  ratings: {
    emptyRating: 'No ratings yet',
    successOnChanged: 'Your rating has been saved',
    failedOnChanged: 'Failed to rate extension',
    youRated: (rating: number) => `You rated: ${rating.toFixed(1)}`
  },
  boardSettings: {
    allExtensions: 'All extensions ↗',
    addExtension: 'Add extension ↗',
    promoTitle: 'More integration &\u00A0automations in\u00A0Extensions',
    promoDescrption: 'Flexible system customization for your work',
    promoActionLink: 'Open Extensions ↗'
  },
  gallery: {
    title: 'Extensions gallery',
    searchPlaceholder: 'Search extensions',
    goBackToGallery: 'Back to gallery',
    goBackToComments: 'Back to comments',
    scrollToTop: 'Scroll to top',
    leaveComment: 'Leave a comment',
    leaveGoodFeedback: 'Tell us what you liked',
    leaveBadFeedback: 'Tell us what you didn’t like',
    filters: {
      all: 'All extensions',
      enabled: 'Enabled',
      new: 'New'
    },
    details: {
      rating: 'Rating',
      noRatings: 'No ratings',
      ratingOutOf: 'out of',
      tags: 'Tags',
      statistics: 'Statistics',
      description: 'Description',
      media: 'Screenshots',
      documentation: 'Documentation'
    },
    sortingOptions: {
      topRated: 'Top rated',
      mostInstalled: 'Most installed',
      mostCommented: 'Most commented',
      releaseDate: 'New ones from above'
    },
    noCommentsYet: 'No comments yet...',
    experimentsNotice: `Early access to draft extensions. They're still a work in progress, but we’re already looking forward to your feedback.`,
    instruction: 'Instruction'
  },
  tags: {
    // The order of tags here respected by the sidebar of Extensions Gallery UI
    strictProcesses: 'Strict processes',
    resourceManagement: 'Resource management',
    integrations: 'Integrations',
    sales: 'Sales',
    automations: 'Automations',
    experiments: 'Experiments'
  }
}

export const extensionsRu: typeof extensionsEn = {
  available: 'Список доступных расширений',
  loadError:
    'Не удалось загрузить список расширений, попробуйте ещё раз через некоторое время',
  addError: 'Не удалось подключить расширение',
  extLimitError:
    'На установку расширений установлен лимит: не более 10 000 включений на всех пользователей YouGile. К сожалению, на данный момент лимит превышен и вы не можете воспользоваться расширением',
  removeError: 'Не удалось отключить расширение',
  addSuccess: 'Расширение успешно подключено',
  remove: 'Отключить',
  globalSettings: 'Глобальные настройки',
  extensions: 'Расширения',
  extensionItem: 'Расширение',
  status: 'Статус расширения',
  enabled: 'Включено',
  disabled: 'Выключено',
  enableOnlyAdmin: (isEnabled: boolean) =>
    `${
      isEnabled ? 'Отключать' : 'Подключать'
    } расширения могут только администраторы компании`,
  rateExtension: 'Оцените расширение',
  setup: 'Настроить расширение',
  extensionsSettings: 'Настройки расширений',
  extensionSettings: 'Настройки расширения',
  createdBy: 'Автор',
  installCustom: 'Установить расширение',
  enable: 'Подключить',
  disable: 'Отключить',
  installsCountHint: `Количество установок`,
  commentsCountHint: `Количество комментариев`,
  supportOnlyZip: 'Поддерживаются только архивы с расширением *.zip',
  successOnInstall: 'Расширение успешно подключено',
  errorOnInstall: 'Не удалось подключить расширение',
  ratings: {
    emptyRating: 'Пока нет оценок',
    successOnChanged: 'Ваша оценка сохранена',
    failedOnChanged: 'Не удалось сохранить вашу оценку',
    youRated: (rating: number) => `Вы оценили: ${rating.toFixed(1)}`
  },
  boardSettings: {
    allExtensions: 'Все расширения ↗',
    addExtension: 'Добавить расширение ↗',
    promoTitle: 'Больше автоматизаций и\u00A0интеграций в\u00A0Расширениях',
    promoDescrption: 'Гибкая настройка системы под вашу работу',
    promoActionLink: 'Открыть Расширения ↗'
  },
  gallery: {
    title: 'Галерея расширений',
    searchPlaceholder: 'Найти расширение',
    goBackToGallery: 'Назад к галерее',
    goBackToComments: 'Назад к комментариям',
    scrollToTop: 'Наверх',
    leaveComment: 'Оставьте комментарий',
    leaveGoodFeedback: 'Расскажите, что понравилось',
    leaveBadFeedback: 'Расскажите, что не понравилось',
    filters: {
      all: 'Все расширения',
      enabled: 'Подключено',
      new: 'Новое'
    },
    details: {
      rating: 'Рейтинг',
      noRatings: 'Нет оценок',
      ratingOutOf: 'из',
      tags: 'Метки',
      statistics: 'Статистика',
      description: 'Описание',
      media: 'Скриншоты',
      documentation: 'Документация'
    },
    sortingOptions: {
      topRated: 'Выше рейтинг',
      mostInstalled: 'Больше установок',
      mostCommented: 'Самые обсуждаемые',
      releaseDate: 'Новые сверху'
    },
    noCommentsYet: 'Пока нет комментариев...',
    experimentsNotice:
      'Ранний доступ к черновым вариантам расширений. Они ещё не закончены, но мы уже хотим получать ваши отзывы.',
    instruction: 'Инструкция'
  },
  tags: {
    // The order of tags here respected by the sidebar of Extensions Gallery UI
    strictProcesses: 'Строгие процессы',
    resourceManagement: 'Управление ресурсами',
    integrations: 'Интеграции',
    sales: 'Продажи',
    automations: 'Автоматизации',
    experiments: 'Эксперименты'
  }
}
